import { render } from "./RatingPreview.vue?vue&type=template&id=1323b4b0&scoped=true"
import script from "./RatingPreview.vue?vue&type=script&lang=js"
export * from "./RatingPreview.vue?vue&type=script&lang=js"

import "./RatingPreview.vue?vue&type=style&index=0&id=1323b4b0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1323b4b0"]])

export default __exports__